var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBallot = function SvgBallot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h32v32H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 13.333h6.667v-2.666H16v2.666Zm0 8h6.667v-2.666H16v2.666Zm-4-6.666c.733 0 1.361-.261 1.883-.784.523-.522.784-1.15.784-1.883 0-.733-.261-1.361-.784-1.883A2.568 2.568 0 0 0 12 9.333c-.733 0-1.361.261-1.883.784A2.568 2.568 0 0 0 9.333 12c0 .733.261 1.361.784 1.883.522.523 1.15.784 1.883.784Zm0 8c.733 0 1.361-.261 1.883-.784.523-.522.784-1.15.784-1.883 0-.733-.261-1.361-.784-1.883A2.568 2.568 0 0 0 12 17.333c-.733 0-1.361.261-1.883.784A2.568 2.568 0 0 0 9.333 20c0 .733.261 1.361.784 1.883.522.523 1.15.784 1.883.784ZM6.667 28a2.568 2.568 0 0 1-1.884-.783A2.568 2.568 0 0 1 4 25.333V6.667c0-.734.261-1.361.783-1.884A2.568 2.568 0 0 1 6.667 4h18.666c.734 0 1.361.261 1.884.783.522.523.783 1.15.783 1.884v18.666c0 .734-.261 1.361-.783 1.884a2.568 2.568 0 0 1-1.884.783H6.667Zm0-2.667h18.666V6.667H6.667v18.666Z",
    fill: "#F92"
  }))));
};
export default SvgBallot;